<template>
  <div class="data-overview-page">
    <div class="chart"
         v-if="chartType">
      <div class="book-chart">
        <div class="title">
          <div class="name">教辅书数据概览</div>
          <div class="details"
               @click="checkDetails(1)">详细数据
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="select-div">
          <van-dropdown-menu active-color="#25C66B"
                             class="book-dropdown book-class-dropdown"
                             :overlay="false">
            <van-dropdown-item class="book-class-dropdown-item"
                               v-model="bookSelectedInfo.book_id"
                               :options="bookList"
                               @opened="openHandle(1)"
                               @closed="closedHandle(1)" />
          </van-dropdown-menu>
        </div>
        <div class="tab-div">
          <div class="tab-list"
               v-for="item in bookTab"
               :key="'book'+item.id"
               :class="{
                active:bookChoose==item.id
               }"
               @click="bookTabClick(item)">
            <div class="val">{{item.val}}</div>
            <div class="name">{{item.name}}</div>
          </div>
        </div>
        <div class="chart-line"
             id="bookLine"
             v-if="book_study_book_statistics_ens.length"></div>
        <NoData class="no-chart-data"
                text="无数据"
                :placeholderImage="require('@/assets/images/no_data.png')"
                v-else />
      </div>
      <div class="book-chart class-chart">
        <div class="title">
          <div class="name">班级数据概览</div>
          <div class="details"
               v-if="classList.length"
               @click="checkDetails(2)">详细数据
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="select-div"
             v-if="classList.length">
          <van-dropdown-menu active-color="#25C66B"
                             class="class-dropdown book-class-dropdown"
                             :overlay="false"
                             ref="dropdownMenuRef">
            <van-dropdown-item class="book-class-dropdown-item"
                               v-model="classSelecetedInfo.class_id"
                               :options="classList"
                               @opened="openHandle(2)"
                               @closed="closedHandle(2)" />
          </van-dropdown-menu>
        </div>
        <div class="tab-div">
          <div class="tab-list"
               v-for="item in classTab"
               :key="'class'+item.id"
               :class="{
                active:classChoose==item.id
               }"
               @click="classTabClick(item)">
            <div class="val">{{item.val}}</div>
            <div class="name">{{item.name}}</div>
          </div>
        </div>
        <div class="chart-line"
             id="classLine"
             v-if="class_study_book_statistics_ens.length"></div>
        <NoData class="no-chart-data"
                text="无数据"
                :placeholderImage="require('@/assets/images/no_data.png')"
                v-else />
      </div>
    </div>
    <NoData text="暂无数据"
            v-else />
  </div>
</template>

<script>
import { HttpFactory } from '@/assets/js/common'
import { setCache, getCache } from '@/assets/js/utils'
import rqParams from './rq'
import classDataRq from '@/views/ClassData/rq'
import NoData from '@/components/NoData/NoData'
export default {
  components: {
    NoData
  },
  data() {
    return {
      chartType: true,
      bookTab: [{
        id: 1,
        name: '学习学生数',
        val: 0
      }, {
        id: 2,
        name: '题目完成度',
        val: '0%'
      }],
      bookChoose: 1,
      bookList: [],
      classTab: [{
        id: 1,
        name: '班级学生数',
        val: 0
      }, {
        id: 2,
        name: '题目完成度',
        val: '0%'
      }],
      classChoose: 1,
      classList: [],
      classDropdown: 1,
      bookSelectedInfo: {
        book_id: '',
        book_name: ''
      },
      classSelecetedInfo: {
        class_id: '',
        class_name: ''
      },
      book_study_book_statistics_ens: [],
      class_study_book_statistics_ens: [],
      requestClassParam: {
        page_no: 0,
        page_size: 20,
        total_count: 0
      },
      bookChartInstance: null,
      classChartInstance: null
    }
  },
  watch: {
    bookList(val) {
      const { book_id, book_name } = getCache('bookSelectedInfo') || {}
      if (!this.bookSelectedInfo.book_id) {
        if (book_id && val.find(f => f.value === book_id)) {
          this.bookSelectedInfo.book_id = book_id
          this.bookSelectedInfo.book_name = book_name
        } else {
          this.bookSelectedInfo.book_id = val[0].value
          this.bookSelectedInfo.book_name = val[0].text
        }
      } else {
        this.bookSelectedInfo.book_name = val.filter(ele => ele.value === this.bookSelectedInfo.book_id)[0].text
      }
      setCache('bookSelectedInfo', this.bookSelectedInfo)
    },
    classList(val) {
      if (!this.classSelecetedInfo.class_id) {
        const { class_id, class_name } = getCache('classSelecetedInfo') || {}
        if (class_id && val.find(f => f.value === class_id)) {
          this.classSelecetedInfo.class_id = class_id
          this.classSelecetedInfo.class_name = class_name
        } else {
          this.classSelecetedInfo.class_id = val[0].value
          this.classSelecetedInfo.class_name = val[0].text
        }
      } else {
        this.classSelecetedInfo.class_name = val.filter(ele => ele.value === this.classSelecetedInfo.class_id)[0].text
      }
      setCache('classSelecetedInfo', this.classSelecetedInfo)
    },
    /**
     * 监听book_id的变化
     */
    'bookSelectedInfo.book_id'(val) {
      if (this.bookList.length > 0) {
        const currentBook = this.bookList.find(ele => ele.value === val)
        this.bookSelectedInfo.book_name = currentBook ? currentBook.text : ''
        setCache('bookSelectedInfo', this.bookSelectedInfo)
        this.getUserStudyStatisticsByBookid()
      }
    },
    'classSelecetedInfo.class_id'(val) {
      if (this.classList.length > 0) {
        const currentClass = this.classList.find(ele => ele.value === val)
        this.classSelecetedInfo.class_name = currentClass ? currentClass.text : ''
        setCache('classSelecetedInfo', this.classSelecetedInfo)
        this.getUserStudyStatisticsByClassid()
      }
    }
  },
  created() {
    this.getbooklistbyproductidandtype()
    this.requestClassParam.page_no = 0
    this.getClassInfoList()
  },
  methods: {
    getbooklistbyproductidandtype() {
      HttpFactory.postEnglishUrl(rqParams.getbooklistbyproductidandtype({
        product_id: process.env.VUE_APP_PRODUCT_ID,
        type: 2
      }), res => {
        res.data.forEach(ele => {
          this.bookList.push({
            value: String(ele.id),
            text: ele.name
          })
        })
      })
    },
    getClassInfoList() {
      HttpFactory.postUrl(classDataRq.getClassInfoList({
        page_no: this.requestClassParam.page_no,
        page_size: this.requestClassParam.page_size
      }), res => {
        res.data.forEach(ele => {
          this.classList.push({
            value: String(ele.id),
            text: ele.class_name
          })
        })
        this.requestClassParam.total_count = res.paginator.total_count || 0
      })
    },
    getUserStudyStatisticsByBookid() {
      HttpFactory.postUrl(rqParams.getUserStudyStatisticsByBookid({
        book_id: this.bookSelectedInfo.book_id
      }), res => {
        const { study_book_statistics_ens, sum_complete_percent, sum_user_count } = res.data || {
          study_book_statistics_ens: [],
          sum_complete_percent: 0,
          sum_user_count: 0
        }
        this.bookTab.forEach((el, index) => {
          if (index === 0) {
            el.val = sum_user_count
          } else if (index === 1) {
            el.val = (sum_complete_percent / 10) + '%'
          }
        })
        this.book_study_book_statistics_ens = study_book_statistics_ens
        this.$nextTick(() => {
          this.lineChart(1, true, this.getAciveBookCharData(), this.bookChoose)
        })
      })
    },
    getUserStudyStatisticsByClassid() {
      HttpFactory.postUrl(rqParams.getUserStudyStatisticsByClassid({
        class_id: this.classSelecetedInfo.class_id
      }), res => {
        const { study_book_statistics_ens, sum_complete_percent, sum_user_count } = res.data || {
          study_book_statistics_ens: [],
          sum_complete_percent: 0,
          sum_user_count: 0
        }
        this.classTab.forEach((el, index) => {
          if (index === 0) {
            el.val = sum_user_count
          } else if (index === 1) {
            el.val = (sum_complete_percent / 10) + '%'
          }
        })
        this.class_study_book_statistics_ens = study_book_statistics_ens
        this.$nextTick(() => {
          this.lineChart(2, true, this.getAciveClassCharData(), this.classChoose)
        })
      })
    },
    getAciveBookCharData() {
      const chartData = this.book_study_book_statistics_ens.map(m => {
        if (this.bookChoose === 1) {
          return m.user_count
        } else {
          return m.complete_percent / 10
        }
      })
      const tiemData = this.book_study_book_statistics_ens.map(m => {
        const time = new Date(m.day * 1000)
        return `${time.getMonth() + 1}/${time.getDate()}`
      })
      return {
        chartData,
        tiemData
      }
    },
    getAciveClassCharData() {
      const chartData = this.class_study_book_statistics_ens.map(m => {
        if (this.classChoose === 1) {
          return m.user_count
        } else {
          return m.complete_percent / 10
        }
      })
      const tiemData = this.class_study_book_statistics_ens.map(m => {
        const time = new Date(m.day * 1000)
        return `${time.getMonth() + 1}/${time.getDate()}`
      })
      return {
        chartData,
        tiemData
      }
    },
    /**
     * 教辅书 学生题目 tab切换
     */
    bookTabClick(item) {
      this.bookChoose = item.id
      this.lineChart(1, false, this.getAciveBookCharData(), item.id)
    },
    /**
     * 班级数据 班级学生数切换
     */
    classTabClick(item) {
      this.classChoose = item.id
      this.lineChart(2, false, this.getAciveClassCharData(), item.id)
    },
    randomRange(min, max) { // min最小值，max最大值
      return Math.floor(Math.random() * (max - min)) + min
    },
    /**
     * 设置弹窗到底部的距离
     */
    openHandle(val) {
      if (val == 1) {
        this.bookChartInstance && this.bookChartInstance.dispatchAction({ type: 'hideTip' })
        const heightData = document.querySelector('.book-dropdown').querySelector('.van-dropdown-item__content').getBoundingClientRect().height
        document.querySelector('.book-dropdown').querySelector('.van-dropdown-item--down').style.height = heightData + 20 + 'px'
        document.querySelector('.book-dropdown').querySelector('.book-class-dropdown-item').style.height = heightData + 20 + 'px'
      } else {
        this.classChartInstance && this.classChartInstance.dispatchAction({ type: 'hideTip' })
        const van_dropdown_item_content = document.querySelector('.class-dropdown').querySelector('.van-dropdown-item__content')
        const heightData = van_dropdown_item_content.getBoundingClientRect().height
        document.querySelector('.class-dropdown').querySelector('.van-dropdown-item--down').style.height = heightData + 20 + 'px'
        document.querySelector('.class-dropdown').querySelector('.book-class-dropdown-item').style.height = heightData + 20 + 'px'
        van_dropdown_item_content.addEventListener('scroll', this.dropdownMenuScroll)
      }
    },
    closedHandle(val) {
      if (val == 1) {
        document.querySelector('.book-dropdown').querySelector('.book-class-dropdown-item').style.height = 0 + 'px'
      } else {
        document.querySelector('.class-dropdown').querySelector('.book-class-dropdown-item').style.height = 0 + 'px'
        const van_dropdown_item_content = document.querySelector('.class-dropdown').querySelector('.van-dropdown-item__content')
        van_dropdown_item_content.removeEventListener('scroll', this.dropdownMenuScroll)
      }
    },
    /**
     * 跳转详情页面  1教辅书  2班级数据
     */
    checkDetails(num) {
      if (num == 1) {
        location.href = './BookDetails.html'
      } else {
        location.href = './ClassDetailsData.html'
      }
    },
    lineChart(num, is_init, { chartData = [], tiemData = [] }, tabNum) {
      // num 1教辅书数据  2班级数据
      // tabNum 1学生数  2完成度
      //  初始化echarts实例
      const target = num === 1 ? document.getElementById('bookLine') : document.getElementById('classLine')
      if (!target) {
        return
      }
      let myChart = null
      if (num === 1) {
        if (is_init) {
          myChart = this.bookChartInstance = this.$echarts.init(target)
        } else {
          // 避免重复实例化
          myChart = this.bookChartInstance
        }
      } else {
        if (is_init) {
          myChart = this.classChartInstance = this.$echarts.init(target)
        } else {
          myChart = this.classChartInstance
        }
      }
      const option = {
        tooltip: {
          trigger: 'item',
          extraCssText: 'background-color:rgba(255,255,255,0.9);border: 1px solid #dcdfe6;color:#909399',
          formatter: function(params) {
            return tabNum === 1 ? `
                        <div>日期：${params.name}</div>
                        <div>学生数：${params.value}</div>
                        `
              : `
                        <div>日期：${params.name}</div>
                        <div>完成度：${params.value}%</div>
                        `
          }
        },
        xAxis: {
          type: 'category',
          data: tiemData,
          nameTextStyle: {
            color: 'rgba(0,0,0,0.45)'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(0,0,0,0.45)'
            }
          },
          axisTick: {
            lineStyle: {
              color: 'rgba(0,0,0,0.45)'
            }
          }
        },
        yAxis: {
          type: 'value',
          nameTextStyle: {
            color: 'rgba(0,0,0,0.45)'
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: 'rgba(0,0,0,0.45)'
            }
          },
          axisTick: {
            show: false
          }
        },
        legend: {
          top: '10',
          left: '10',
          right: '10',
          bottom: '10'
        },
        grid: {
          top: '10',
          left: '10',
          right: '10',
          bottom: '10',
          containLabel: true
        },
        series: [
          {
            data: chartData,
            type: 'line',
            smooth: true,
            symbolSize: 7,
            itemStyle: {
              color: num == 1 ? '#519FF4' : '#0EC9B7',
              lineStyle: {
                color: num == 1 ? '#519FF4' : '#0EC9B7',
                width: 3
              }
            }
          }
        ]
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
    },
    dropdownMenuScroll({ target }) {
      if (target.scrollTop + target.clientHeight >= target.scrollHeight) {
        if (this.requestClassParam.total_count > this.requestClassParam.page_no * this.requestClassParam.page_size + this.requestClassParam.page_size) {
          this.requestClassParam.page_no++
          this.getClassInfoList()
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/dropdown.less';
.data-overview-page {
  display: flex;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: #ebf1f6;
  .chart {
    background: #fff;
    width: 100%;
    .book-chart {
      height: 339px;
      background: linear-gradient(
        180deg,
        #cfe6f7 0%,
        #fcfdff 54%,
        #ffffff 100%
      );
      padding: 16px 20px;
      display: flex;
      flex-direction: column;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name {
          font-size: 16px;
          color: #333333;
        }
        .details {
          color: #3890f0;
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: bold;
          cursor: pointer;
          line-height: 30px;
          i{
            position: relative;
            top: -0.3px;
          }
        }
      }
      &.class-chart {
        background: linear-gradient(
          180deg,
          #d7f5f3 0%,
          #fcfdff 58%,
          #ffffff 100%
        );
        .tab-list {
          &.active {
            background: linear-gradient(180deg, #56dedf 0%, #0bd5c0 100%);
            div {
              color: #fff;
            }
          }
          .val {
            color: #0ec9b7;
          }
        }
        .title {
          .details {
            color: #0ec9b7;
          }
        }
      }
    }
    .tab-div {
      display: flex;
      margin: 10px 0 20px 0;
      .tab-list {
        margin-right: 10px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: flex-start;
        width: 86px;
        height: 55px;
        border-radius: 10px;
        background: #fff;
        cursor: pointer;
        > div {
          width: 100%;
          text-align: center;
        }
        &.active {
          background: linear-gradient(180deg, #51ccf4 0%, #519ff4 100%);
          div {
            color: #fff;
          }
        }
        .val {
          font-size: 18px;
          font-weight: bold;
          color: #519ff4;
        }
        .name {
          font-size: 12px;
          color: #4a4a4a;
        }
      }
    }
    .chart-line {
      width: 100%;
      flex: 1;
    }
  }
}
/deep/ .noData {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  img {
    width: 295px;
    height: auto;
  }

  span {
    font-size: 14px;
    font-weight: 400;
    color: rgba(116, 118, 125, 1);
    text-align: center;
  }
}
/deep/ .noData.no-chart-data {
  img {
    width: 53px;
    height: 56px;
  }
  .text {
    color: #bbb;
  }
}
</style>
